import { render, staticRenderFns } from "./testDataTable.vue?vue&type=template&id=4de7bea6&"
import script from "./testDataTable.vue?vue&type=script&lang=js&"
export * from "./testDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports